
import { MercanciaDatosComplementarios } from "../../entities/solicitudes/MercanciaDatosComplementarios";

export const SAVE_MERCANCIASCOMPLEMENTARIO = "SAVE_MERCANCIASCOMPLEMENTARIO";

interface ISaveMercancias {
    type: typeof SAVE_MERCANCIASCOMPLEMENTARIO
    mercanciasDatosComplementarios: MercanciaDatosComplementarios[]
}

export type MercanciaDatosComplementariosActionTypes = ISaveMercancias
